export const currentPage = (value) => {
  return value % 20 === 0 ? value / 20 + 1 : Math.ceil(value / 20);
};

export const totalPage = (value) => {
  return value % 20 === 0 ? value / 20 : Math.ceil(value / 20);
};
